var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0913 12.6944V2",
    stroke: "#2E37A4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0913 36.9991V26.3047",
    stroke: "#2E37A4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2031 2H22.9809",
    stroke: "#2E37A4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2031 37H22.9809",
    stroke: "#2E37A4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1994 16.0972L3.94385 10.75",
    stroke: "#2E37A4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2385 28.2535L24.9829 22.9062",
    stroke: "#2E37A4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.1106L5.88889 7.38281",
    stroke: "#2E37A4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2944 31.6106L36.1833 24.8828",
    stroke: "#2E37A4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2385 10.75L24.9829 16.0972",
    stroke: "#2E37A4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1994 22.9062L3.94385 28.2535",
    stroke: "#2E37A4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1833 14.1106L32.2944 7.38281",
    stroke: "#2E37A4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88889 31.6106L2 24.8828",
    stroke: "#2E37A4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8972 19.5009C25.8972 20.7453 25.5667 21.8925 24.9834 22.9036C23.7972 24.9453 21.6 26.3064 19.0917 26.3064C16.5834 26.3064 14.3861 24.9453 13.2 22.9036C12.6167 21.8925 12.2861 20.7453 12.2861 19.5009C12.2861 18.2564 12.6167 17.1092 13.2 16.0981C14.3861 14.0564 16.5834 12.6953 19.0917 12.6953C21.6 12.6953 23.7972 14.0564 24.9834 16.0981C25.5667 17.1092 25.8972 18.2564 25.8972 19.5009Z",
    stroke: "#00D3C7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon02);
export default __webpack_public_path__ + "static/media/report-icon-02.f3cfda40b06380cbf4f35b72d0fa7439.svg";
export { ForwardRef as ReactComponent };